import { Duration } from "PFApp/booking/booking_edit_mode_store";
import { useCalculateTotalHours } from "PFApp/booking/hooks/use_calculate_total_hours";
import { BookingForUpdate } from "PFCore/services/bookings_bulk_operation";
import { RequirementType } from "PFTypes";

type UseFilterBookingsByDurationReturn = {
  filterBookingsByDuration: (filteredBookings: BookingForUpdate[], duration: Duration) => BookingForUpdate[];
};

export const useFilterBookingsByDuration = (): UseFilterBookingsByDurationReturn => {
  const { calculateTotalHours } = useCalculateTotalHours();

  const filterBookingsByDuration = (filteredBookings: BookingForUpdate[], duration: Duration) => {
    if (duration.durationType !== RequirementType.TotalHours) {
      return filteredBookings;
    }

    return filteredBookings.filter(({ startDate, endDate }) => {
      const bookingTotalHours = calculateTotalHours(startDate, endDate);

      return bookingTotalHours > (duration.durationValue ?? 0);
    });
  };

  return {
    filterBookingsByDuration
  };
};
